/* eslint-disable import/prefer-default-export */
import Vue from "vue";
import { liveCourseEntity } from "../../services/adminApis/liveCourseEntityApi";
import { customerApi } from "../../services/customerApi";

export const liveCourseJs = new Vue({
  methods: {
    async addLiveCourse(courseData, token) {
      const requestData = {
        name: courseData.name,
        duration: courseData.duration,
        imageUrl: courseData.imageUrl,
        totalSession: courseData.totalSession,
        price: courseData.price,
        roomNumber: 0,
        subject: courseData.subject,
        description: courseData.description,
        categoryId: courseData.category.category_id,
        courseSpeciality: courseData.courseSpeciality.join(","),
        liveCourseProperties: courseData.courseProperties
      };
      const response = await liveCourseEntity.addLiveCourse(requestData, token);
      return response;
    },
    async editLiveCourse(courseData, token) {
      const requestData = {
        courseId: courseData.courseId,
        name: courseData.name,
        duration: courseData.duration,
        imageUrl: courseData.imageUrl,
        totalSession: courseData.totalSession,
        roomNumber: courseData.roomNumber,
        price: courseData.price,
        subject: courseData.subject,
        description: courseData.description,
        categoryId: courseData.categoryId,
        courseSpeciality: courseData.courseSpeciality.join(","),
        liveCourseProperties: courseData.courseProperties
      };
      const response = await liveCourseEntity.editLiveCourse(
        requestData,
        token
      );
      await customerApi.getTeacherCourses();
      return response;
    }
  }
});
